import {
  createRouter as createTanStackRouter,
  parseSearchWith,
  stringifySearchWith,
} from '@tanstack/react-router'
import * as JSURL2 from 'jsurl2'

import { routeTree } from '@/routeTree.gen'
import { queryClient } from './tanstack-query'

export function createRouter() {
  const router = createTanStackRouter({
    routeTree,
    defaultPreload: false,
    defaultPreloadStaleTime: 0,
    defaultViewTransition: true,
    trailingSlash: 'never',
    notFoundMode: 'fuzzy',
    // Handled by react query
    defaultStaleTime: 0,
    defaultGcTime: 0,
    context: { qc: queryClient },
    parseSearch: parseSearchWith(JSURL2.parse),
    stringifySearch: stringifySearchWith(JSURL2.stringify, JSURL2.parse),
    scrollRestoration: true,
    // defaultPendingComponent: (...props) => {
    //   return (
    //     <div className="bg-persian-red-300/10 absolute inset-0 flex items-center justify-center">
    //       <Spinner className="fill-persian-red-600 h-8 w-8" />
    //       <p className="text-persian-red-600 ml-3 font-bold">Loading...</p>
    //     </div>
    //   )
    // },
  })

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>
  }
}
